/**
    商品列表
**/
<template>
  <div class="rightaside_content">
    <h3 class="headerTitle">我的退款</h3>
    <div class="headerButton">
      <span style="line-height: 28px"
        >订单号：<i>{{ myRefundInfo.orderNumber }}</i></span
      >
      <!-- <div>
                    <el-button size="mini" @click="$router.push('/orderNow')">去支付</el-button>
                    <el-button size="mini" @click="cancleOrder">取消订单</el-button>
              </div> -->
    </div>
    <el-divider></el-divider>
    <div>
      <!-- <el-row class="order_goods" v-for="(item,index) in myRefundInfo.goodsItem" :key='index'>
                    <el-col :span="2"> <el-image :src="`${item.photos}`"></el-image></el-col> 
                    <el-col :span="15" class="order_Info_item">
                       <p>{{item.name}}</p>
                        <p>{{item.realprice}} 元 * {{item.number}}</p>
                    </el-col>
                </el-row> -->
      <el-row class="order_goods" >
        <el-col :span="2" >
          <el-image :src="`${myRefundInfo.goodsItem.photos}`" ></el-image
        ></el-col>
        <el-col :span="15" class="order_Info_item">
          <p style="margin-left:15px">
            {{ myRefundInfo.goodsItem.name }}
            <!-- {{goodsItem.specificationlist.length>0?goodsItem.specificationlist[0].attributeContent:'默认规格'}} -->
            {{
              myRefundInfo.goodsItem.specificationlist.length >0
                ? myRefundInfo.goodsItem.specificationlist[0].attributeContent 
                : "默认规格"
            }}
          </p>
          <p style="margin-left:15px">
            {{ myRefundInfo.goodsItem.realprice }} 元 *
            {{ myRefundInfo.goodsItem.number }}
          </p>
        </el-col>
      </el-row>
      <el-row v-if="type == 2">
        <el-col
          :span="24"
          class="selectItem"
          @click.native="selecttypeClick(1)"
        >
          <div class="selectItemIcon">¥</div>
          <div class="selectItemText">
            <p>我要退款(无需退货)</p>
            <p class="selectItemTextSmall">
              没收到货，或与卖家协商同意不用退货只退款
            </p>
          </div>
        </el-col>
        <el-col :span="24">
          <el-divider></el-divider>
        </el-col>
        <el-col
          :span="24"
          class="selectItem"
          @click.native="selecttypeClick(2)"
        >
          <div class="selectItemIcon">退</div>
          <div class="selectItemText">
            <p>我要退货退款</p>
            <p class="selectItemTextSmall">已收到货，需要退还收到的货物</p>
          </div>
        </el-col>
      </el-row>
      <el-row class="myRefund" v-else>
        <el-col :span="24"> <h3 class="headerTitle">退款申请</h3></el-col>
        <el-col>
          <el-form
            :rules="rules"
            ref="sizeForm"
            :model="sizeForm"
            label-width="80px"
            size="mini"
          >
            <el-form-item label="退款原因" prop="reasaon">
              <el-select v-model="sizeForm.reasaon" placeholder="请选择">
                <el-option
                  v-for="item in reasaonList"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="货物状态"
              prop="reasaon"
              v-if="selecttype == 2"
            >
              <el-select v-model="sizeForm.returnType" placeholder="请选择">
                <el-option label="已收到货" value="1"></el-option>
                <el-option label="未收到货" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="退款金额" prop="amount">
              <el-input disabled v-model="sizeForm.amount"></el-input>
            </el-form-item>
            <el-form-item label="退款说明" prop="description">
              <el-input
                v-model="sizeForm.description"
                placeholder="输入您要退款的说明文字"
              ></el-input>
            </el-form-item>
            <el-form-item label="退款凭证" prop="" class="myproof">
              <el-upload
                name="files"
                class="avatar-uploader"
                :action="`${$baseUrl}/custom/xunyou/api/common/upload`"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
              >
                <el-image v-if="sizeForm.proof"  class="avatar" :src="urlImg">
                                                <div  slot="error" class="image-slot bg-font-size-big">
                                                    <i   class="el-icon-user"></i>
                                                </div>
                     </el-image>
                <!-- <img v-if="sizeForm.proof" :src="urlImg" class="avatar" /> -->
                <i v-else class="el-icon-plus avatar-uploader-icon"></i> 
              </el-upload>
            </el-form-item>
            <el-form-item size="large">
              <el-button
                v-if="isNewAddstatus == 1"
                type="primary"
                @click="submitApply"
                size="mini"
                class="buttonBgd"
                >申请退款</el-button
              >
              <el-button
                v-if="isNewAddstatus == 2"
                type="primary"
                @click="editApply"
                size="mini"
                class="buttonBgd"
                >申请退款</el-button
              >
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>
    <!-- 退款失败 -->
    <el-dialog
      :visible.sync="backdialogVisible"
      width="30%"
      center
      class="dialogBox"
    >
      <div class="textCenter">{{ msg }}</div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="backdialogVisible = false"
          class="buttonBgd"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  backMoney,
  xy_personvalue,
  addbackMoney,
  getDictData,
  returnAmount,
  editbackMoney,
  backMoneyList,
  showorderDetail,
  wyRefund,
} from "@/api/xunyou";
export default {
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
      type: 2, //0首页,1退款,2退货退款
      status: 0, //1退款2退款修改
      selecttype: "", //1.我要退款；2.我要退货退款
      msg: "",
      backdialogVisible: false,
      myRefundInfo: JSON.parse(sessionStorage.getItem("myRefundInfo")) || [],
      orderGoodsInfo:
        JSON.parse(sessionStorage.getItem("orderGoodsInfo")) || [],
      urlImg: "", // 用来图片预览的
      sizeForm: {
        reasaon: "",
        amount: JSON.parse(sessionStorage.getItem("myRefundInfo")).amount,
        description: "",
        proof: "",
        returnType: "",
      },
      transactionMode: "",
      orderInfoList: {},
      reasaonList: [],
      isNewAddstatus: 1,
      rules: {
        reasaon: [
          {
            required: true,
            message: "不能为空,请输入",
            trigger: ["blur", "change"],
          },
        ],
        amount: [
          {
            required: true,
            message: "不能为空,请输入",
            trigger: ["blur", "change"],
          },
        ],
        description: [
          {
            required: true,
            message: "不能为空,请输入",
            trigger: ["blur", "change"],
          },
        ],
        proof: [
          {
            required: true,
            message: "不能为空,请输入",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  // 注册组件
  components: {},
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getOrderDetail();
  },
  mounted() {
    if (this.$route.query.status == 1) {
      this.isNewAddstatus = 1;
    } else {
      this.isNewAddstatus = 2;
    }
    this.backReason();
    this.getreturnAmount();
    this.getbackMoneyList();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    //   1.我要退款；2.我要退货退款
    selecttypeClick(type) {
      this.selecttype = type;
      this.type = 1;
    },

    //   查询退款原因
    backReason() {
      getDictData({
        key: "b_xy_deal_after_sale_reason",
      }).then((res) => {
        if (res.code == 0) {
          this.reasaonList = res.data;
        } else {
          this.$message({
            type: "info",
            message: res.msg,
          });
        }
      });
    },

    // 查询退款金额
    getreturnAmount() {
      returnAmount({
        oid: this.myRefundInfo.oid,
        bxysid:
          this.myRefundInfo.goodsItem.specificationlist.length > 0
            ? this.myRefundInfo.goodsItem.specificationlist[0].id
            : 0,
      }).then((res) => {
        if (res.code == 0) {
          this.sizeForm.amount = Number(res.data).toFixed(2);
        } else {
          this.$message({
            type: "info",
            message: res.msg,
          });
        }
      });
    },

    //   查询退款详情 （列表）
    getbackMoneyList() {
      backMoneyList({
        uid: this.userInfo.userId,
        asOid: this.myRefundInfo.goodsItem.returnOrder,
        bXyOasid: this.myRefundInfo.bXyOasid || "",
      }).then((res) => {
        if (res.code == 0) {
          this.orderInfoList = res.rows[0];
        } else {
          this.$message({
            type: "info",
            message: res.msg,
          });
        }
      });
    },
    //   查询订单详情
    getOrderDetail() {
      showorderDetail({ oid: this.myRefundInfo.oid }).then((res) => {
        if (res.code == 0) {
          this.transactionMode = res.rows[0].transactionMode;
          console.log(this.transactionMode, "transactionMod");
        }
      });
    },
    submitApply() {
      console.log(
        this.transactionMode,
        "this.orderGoodsInfo[0].transactionMode"
      );

      this.$refs.sizeForm.validate((valid) => {
        if (valid) {
          //  this.$router.push('/myOrder')
          const req = {
            uid: this.userInfo.userId,
            oid: this.myRefundInfo.oid,
            goodsId: this.myRefundInfo.goodsItem.id,
            type: this.selecttype, // 申请类型 this.type,//1退款2退货退款
            refundAmount: this.sizeForm.amount, // 退款金额
            reason: this.sizeForm.reasaon, // 退款原因
            returnType: this.selecttype == 1 ? 2 : this.sizeForm.returnType, // 退货类型 1：需要退货，2.不用退货。 是否需要退货 没发货之前不需要退货
            remarks: this.sizeForm.description, // 退款说明
            bxysid:
              this.myRefundInfo.goodsItem.specificationlist.length > 0
                ? this.myRefundInfo.goodsItem.specificationlist[0].id
                : 0,
            paymentProof: this.sizeForm.proof.toString(), //图片
          };
          //   transactionMode：1线下，2或者空余额，3网银
          if (this.transactionMode == 3) {
            console.log("网银");
            wyRefund({
              terminal: "PC",
              outTradeNo: this.myRefundInfo.orderNumber,
            })
              .then((res) => {
                // console.log(res, res);
                if (res.code == 0) {
                  if (
                    res.data.biz_msg == "退款失败,[订单状态不正确]无法退款!" ||  res.data.biz_msg =='账户余额不足'
                  ) {
                    this.backdialogVisible = false;
                     this.$message({
                      type: "error",
                      message: res.data.biz_msg,
                    });
                  } else {
                    this.$router.push("/refund");
                    this.$message({
                      type: "success",
                      message: res.data.biz_msg,
                    });
                    sessionStorage.removeItem("myRefundInfo");
                  }
                } else {
                  this.msg = res.msg;
                  this.backdialogVisible = true;
                }
              })
              .catch((err) => {
                this.$message.error("提交失败，请稍后再试！");
              });
          } else if (
            this.transactionMode == null ||
            this.transactionMode == 2
          ) {
            console.log("余额支付");
            //余额支付
            addbackMoney(req)
              .then((res) => {
                if (res.code == 0) {
                  this.$router.push("/refund");
                  this.$message({
                    type: "success",
                    message: res.msg,
                  });
                  sessionStorage.removeItem("myRefundInfo");
                } else {
                  this.msg = res.msg;
                  this.backdialogVisible = true;
                }
              })
              .catch((err) => {
                this.$message.error("提交失败，请稍后再试！");
              });
          }
        }
      });
    },

    // 修改
    editApply() {
      this.$refs.sizeForm.validate((valid) => {
        if (valid) {
          //  this.$router.push('/myOrder')
          const req = {
            bXyOasid: this.orderInfoList.bXyOasid,
            uid: this.userInfo.userId,
            oid: this.myRefundInfo.oid, //
            goodsId: this.myRefundInfo.goodsItem.id,
            type: this.selecttype, // 申请类型 this.type,//1退款2退货退款
            refundAmount: this.sizeForm.amount, // 退款金额
            reason: this.sizeForm.reasaon, // 退款原因
            returnType: this.sizeForm.returnType, // 退货类型 1：需要退货，2.不用退货。 是否需要退货 没发货之前不需要退货
            remarks: this.sizeForm.description, // 退款说明
            bxysid:
              this.myRefundInfo.goodsItem.specificationlist.length > 0
                ? this.myRefundInfo.goodsItem.specificationlist[0].id
                : 0, //
            paymentProof: this.sizeForm.proof.toString(), //图片
            createTime: this.isNewAddstatus == 2 ? new Date().getTime() : "", //有值时，说明是重新申请
          };
          editbackMoney(req)
            .then((res) => {
              if (res.code == 0) {
                this.$router.push("/refund");
                this.$message({
                  type: "success",
                  message: res.msg,
                });
                sessionStorage.removeItem("myRefundInfo");
              } else {
                this.msg = res.msg;
                this.backdialogVisible = true;
              }
            })
            .catch((err) => {
              this.$message.error("提交失败，请稍后再试！");
            });
        }
      });
    },

    //   退款凭证上传
    handleAvatarSuccess(res, file) {
         this.urlImg = URL.createObjectURL(file.raw) // 用来图片预览的
           this.sizeForm.proof =res.url;
      // console.log(file.raw, URL.createObjectURL(file.raw));
      // this.urlImg = URL.createObjectURL(file.raw); // 用来图片预览的
      // this.sizeForm.proof = URL.createObjectURL(file.raw);
      // this.sizeForm.businessLicense =URL.createObjectURL(file.raw). substring(URL.createObjectURL(file.raw).lastIndexOf("/"));
    },
    beforeAvatarUpload(file) {
      // const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      // if (!isJPG) {
      // this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
  },
};
</script>

<style scoped lang="less">
.rightaside_content {
  .el-divider--horizontal {
    display: block;
    height: 1px;
    width: 100%;
    margin: 5px 0;
  }
  .headerTitle {
    font-size: 20px;
    height: 40px;
    line-height: 40px;
    color: #666;
    margin-bottom: 20px;
  }
  .headerButton {
    display: flex;
    justify-content: space-between;
    button.el-button.el-button--default.el-button--mini {
      // background: #ff6700;
      // color: white;
      background: #f896521a;
      color: #ff6700;
      border: 1px solid #ff6700;
    }
    .el-button.el-button--mini:focus,
    .el-button.el-button--mini:hover {
      background: #ff6700 !important;
      color: white !important;
    }
  }
  .order_goods.el-row {
    border-bottom: 1px solid#DCDFE6;
    padding: 20px;
    box-sizing: border-box;
  }
  .myRefund {
    padding: 40px 20px;
    box-sizing: border-box;
    /deep/input[disabled],
    input[disabled="disabled"],
    /deep/input[readonly],
    /deep/input[readonly="readonly"] {
      background: white !important;
    }
    /deep/.el-select.el-select--mini {
      width: 100%;
    }
    /deep/.avatar-uploader {
      padding: 20px 0;
      box-sizing: border-box;
    }
    /deep/.el-upload.el-upload--text {
      border: 1px solid #ccc;
    }

    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
    .avatar {
      width: 160px;
      height: 160px;
      display: block;
    }
    .el-form-item.myproof.el-form-item--mini {
      border-bottom: 1px solid #ccc;
    }
    button.el-button.buttonBgd.el-button--primary {
      background-color: #ff6700;
      border-color: #ff6700;
      font-size: 14px;
      margin: 20px 0;
    }
  }

  .textCenter {
    text-align: center;
    font-size: 25px;
  }
  button.el-button.buttonBgd.el-button--primary {
    background-color: #ff6700;
    border-color: #ff6700;
    font-size: 18px;
    margin: 20px 0;
  }
}
.selectItem {
  display: flex;
  margin: 15px 20px;
  .selectItemIcon {
    line-height: 30px;
    text-align: center;
    font-size: 20px;
    height: 30px;
    width: 30px;
    -webkit-border-radius: 50%;
    border-radius: 50%;
    color: #e50f41;
    border: 0.5px solid #e50f41;
    margin: 4px 17px 0 0;
    cursor: pointer;
  }
  .selectItemText {
    font-size: 14px;
    cursor: pointer;
    .selectItemTextSmall {
      font-size: 12px;
      color: #999999;
      margin: 2px 0 0 0;
    }
  }
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/myOrder/myRefund.vue